import ScanResult from './scan_result'
export default ScanResult;
